import React, { useCallback } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'

import cn from 'classnames'
import { PageTitle } from 'Components/PageTitle'

import ADMEmptyState from '../../../../Assets/Images/icons/admEmptyState'
import { CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE } from '../../../../shared/constants'

import { EmptyStateSimpleBtn } from '../CampaignEmptyStateButtons'
import EmptyStateMessage from '../EmptyStateMessage'
import usePosthogAnalyticsADM from './hooks/usePosthogAnalyticsADM'
const CampaignEmptyStateADM = ({
  classes,
  isSelfServeEnabled,
  handleCreateCampaign,
  validRoute,
  enabledChannel,
  route,
  subRoute,
}) => {
  const { emitAnalyticsEvent } = usePosthogAnalyticsADM()

  const handleClick = useCallback(async () => {
    await handleCreateCampaign()
    emitAnalyticsEvent()
  }, [handleCreateCampaign])

  return (
    <React.Fragment>
      {!enabledChannel && (
        <EmptyStateMessage title="Sorry, this channel is currently not available to create a campaign in your country." />
      )}
      <Box className={classes.campaignWrapper}>
        <PageTitle className={classes.title}>
          {CAMPAING_TYPE_PARAM_TO_EMPTY_TITLE[subRoute ? subRoute : route]}
        </PageTitle>
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Grid item xs={12} sm={7}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <p className={classes.emptyStateText}>
                By sending personalized messages straight to their mailbox, you
                ensure your communication stands out and makes an impression.
              </p>
              <p className={classes.emptyStateText}>
                Simply upload your address list to target the right recipients
                with ease. This channel combines precision with tangible impact,
                helping you build stronger connections and achieve your
                marketing goals.
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} className="text-center">
            <ADMEmptyState />
          </Grid>
        </Grid>
        {validRoute && enabledChannel && (
          <Box className={cn(classes.btnWrapper, classes.btnWrapperMargin)}>
            <Typography className={classes.btnTitle}>
              Let's create your first campaign!
            </Typography>
            {isSelfServeEnabled && (
              <EmptyStateSimpleBtn classes={classes} onClick={handleClick} />
            )}
          </Box>
        )}
      </Box>
    </React.Fragment>
  )
}

export default CampaignEmptyStateADM
